import React from 'react';
import styled, { StyledComponentProps } from 'styled-components';
import { convertPropsToCssRules } from '../../../helpers/styled';

/* Types */
export interface WrapperPropsToPaste {
  backgroundColor?: string;
  color?: string;
  fontConfig?: {
    fontFamily?: string;
    fontSize?: string;
  };
  height?: string;
  hover?: {
    textDecoration?: string;
  };
  letterSpacing?: string;
  onClick?: () => void;
  padding?: string;
  width?: string;
}
export type WrapperProps = StyledComponentProps<'div', any, WrapperPropsToPaste, never>;

export type ItemProps = WrapperProps & {
  bullet?: { regular: React.ReactNode; selected?: React.ReactNode };
  selected?: boolean;
};

/* Components */
const Wrapper = styled.div.attrs({ className: 'icb' as string })<WrapperProps>`
  ${convertPropsToCssRules<WrapperPropsToPaste>([
    'backgroundColor',
    'color',
    'fontConfig',
    'height',
    'letterSpacing',
    'padding',
    'width',
  ])};
  display: flex;
  flex-direction: row;

  ${({ hover, hover: { textDecoration } }) =>
    hover
      ? `&:hover {
          ${textDecoration ? `text-decoration: ${textDecoration};` : ''}
         }`
      : ''}
`;

export const Item: React.FC<ItemProps> = React.memo(({ children, bullet, selected, onClick, ...restProps }) => (
  <Wrapper {...restProps} onClick={onClick}>
    {bullet ? (
      <div className="icb" style={{ height: '100%' }}>
        {selected && bullet.selected ? bullet.selected : bullet.regular}
      </div>
    ) : null}
    <div className="icb" style={{ flex: 1 }}>
      {children}
    </div>
  </Wrapper>
));
